
import { jsPDF } from "jspdf";
import { numberFormat } from "utils";
// import { toBahtText } from "utils/toBahtText";
import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"
import { printHeader } from "../pirntHeader";
import dayjs from "dayjs";

export const printSubcontractPV = ({ pvData, msData }) => {
  console.log("pvData data::", pvData)

  //---------------------------------------------Start Print-----------------------------------------------------------


  const pageSize = [8.3, 11.7];
  const doc = new jsPDF({
    orientation: "lanscape",
    unit: "in",
    format: pageSize
  });


  const companyData = msData.serverData.CompanyData
  doc.setLineWidth(0.01)
  doc.setFont("THSarabun")
  const contentSize = 14;
  const lineHeight = 0.21
  const startY = 0.3
  const startX = 0.4

  const pl = 0.1;

  const totalRow = pvData.Exps.length
  const MAX_ROW = 25
  let curRow = 0
  let yPos = startY
  let xPos = startX
  // let pageNo = 0
  let no = 0
  let pageRow = 0
  let endLoop = false
  let sumExp1 = 0
  let sumExpOth = 0
  let sumTotal = 0
  let sumWhtPr = 0;
  const exps = []
  while (!endLoop) {
    // pageNo++


    xPos = startX
    yPos = startY
    yPos = printHeader({ jsPDFDoc: doc, companyData, startX: xPos, startY: yPos })

    //----------------------------------------------- Top right data ------------------------------------------------
    yPos = startY + 0.2
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(22)
    const xPosTopRight = 8.5
    doc.text("รายงานการจ่ายเงิน", xPosTopRight, yPos)

    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentSize)
    const lineHeightTopRight = lineHeight + lineHeight / 5
    const yPosTopRight = yPos + lineHeightTopRight
    xPos = xPosTopRight
    yPos = yPosTopRight

    doc.text("เลขที่เอกสาร : ", xPos, yPos)
    yPos += lineHeightTopRight
    doc.text("วันที่เอกสาร : ", xPos, yPos)
    yPos += lineHeightTopRight
    doc.text("ผู้รับเงิน : ", xPos, yPos)
    yPos += lineHeightTopRight
    doc.text("จำนวนเงิน : ", xPos, yPos)
    yPos += lineHeightTopRight
    doc.setFont("THSarabun", "normal")
    yPos = yPosTopRight
    xPos += 0.9
    doc.text(pvData.PV.PVNo || "-", xPos, yPos)
    yPos += lineHeightTopRight
    doc.text(dayjs(pvData.PV.PVDte).format("DD/MM/YYYY"), xPos, yPos)
    yPos += lineHeightTopRight
    doc.text(pvData.Sc.Name, xPos, yPos)
    yPos += lineHeightTopRight
    doc.text(numberFormat(+pvData.PV.PayAmnt) + " บาท", xPos, yPos)
    yPos += lineHeightTopRight

    yPos -= 0.1

    //----------------------------------------------- data table ------------------------------------------------
    const colNoWidth = 0.3
    const colScInvNoWidth = 1.1
    const colXpssDocNumWidth = 0.8
    const colScInvDteWidth = 0.8
    const colJobNoWidth = 0.8
    const colCmdyTypWidth = 0.8
    const colLocWidth = 1.6
    const colContNoWidth = 1
    const colDriverWidth = 0.9
    const colLicNmWidth = 0.5
    const colTrnsAmntWidth = 0.8
    const colOthAmntWidth = 0.8
    const colTotalWidth = 0.8
    const boxWidth = colNoWidth + colScInvNoWidth + colXpssDocNumWidth + colScInvDteWidth + colLocWidth + colContNoWidth + colTrnsAmntWidth
      + colOthAmntWidth + colTotalWidth + colDriverWidth + colLicNmWidth + colJobNoWidth + colCmdyTypWidth
    const colNo = startX
    const colXpssDocNum = colNo + colNoWidth
    const colScInvNo = colXpssDocNum + colXpssDocNumWidth
    const colScInvDte = colScInvNo + colScInvNoWidth
    const colJobNo = colScInvDte + colScInvDteWidth
    const colCmdyTyp = colJobNo + colJobNoWidth
    const colLoc = colCmdyTyp + colCmdyTypWidth
    const colContNo = colLoc + colLocWidth
    const colDriver = colContNo + colContNoWidth
    const colLicNm = colDriver + colDriverWidth
    const colTrnsAmnt = colLicNm + colLicNmWidth
    const colOthAmnt = colTrnsAmnt + colTrnsAmntWidth
    const colTotal = colOthAmnt + colOthAmntWidth

    doc.setFontSize(contentSize-1)
    doc.setFillColor("#cce6ff");
    doc.rect(colNo, yPos, boxWidth, lineHeight + 0.1, "F")
    yPos += lineHeight
    doc.text("No.", colNo + colNoWidth / 2, yPos, { align: "center" })
    doc.text("รหัส Express", colXpssDocNum + colXpssDocNumWidth / 2, yPos, { align: "center" })
    doc.text("เลขที่ใบแจ้งหนี้", colScInvNo + colScInvNoWidth / 2, yPos, { align: "center" })
    doc.text("วันที่", colScInvDte + colScInvDteWidth / 2, yPos, { align: "center" })
    doc.text("JobNo", colJobNo + colJobNoWidth / 2, yPos, { align: "center" })
    doc.text("สินค้า", colCmdyTyp + colCmdyTypWidth / 2, yPos, { align: "center" })
    doc.text("สถานที่", colLoc + colLocWidth / 2, yPos, { align: "center" })
    doc.text("หมายเลขตู้", colContNo + colContNoWidth / 2, yPos, { align: "center" })
    doc.text("พนักงานขับรถ", colDriver + colDriverWidth / 2, yPos, { align: "center" })
    doc.text("ทะเบียนรถ", colLicNm + colLicNmWidth / 2, yPos, { align: "center" })
    doc.text("ค่าขนส่ง", colTrnsAmnt + colTrnsAmntWidth / 2, yPos, { align: "center" })
    doc.text("ค่าอื่นๆ", colOthAmnt + colOthAmntWidth / 2, yPos, { align: "center" })
    doc.text("รวม", colTotal + colTotalWidth / 2, yPos, { align: "center" })
    yPos += lineHeight + 0.1
    // for (const row of pvData.Exps) {
    const lineHeightTable = lineHeight - 0.01
    for (let i = curRow; i < totalRow && i < curRow + MAX_ROW; i++) {
      const row = pvData.Exps[i]
      pageRow++
      no++
      if (row.id <= 0) continue
      let exp1Amnt = 0;
      let expOthAmnt = 0;
      let totalAmnt = 0;
      for (const exp of row.RawExps) {
        if (exp.ExpId === 1) {
          sumExp1 += +exp.Total
          exp1Amnt += +exp.Total
        } else {
          sumExpOth += +exp.Total
          expOthAmnt += +exp.Total
        }
        totalAmnt += +exp.Total
        sumTotal += +exp.Total
        sumWhtPr += +exp.WhtPr
        const foundExp = exps.find(e => e.ExpId === exp.ExpId && e.UntPr === exp.UntPr)
        if (foundExp) {
          foundExp.Qty += +exp.Qty
          foundExp.Total += +exp.Total
        } else {
          exps.push({ ...exp })
        }
      }
      doc.text(no.toString(), colNo + colNoWidth / 2, yPos, { align: "center" })
      doc.text(row.XpssDocNum || "-", colXpssDocNum + pl, yPos)
      doc.text(row.ScInvNo, colScInvNo + pl, yPos)
      doc.text(row.ScInvDte ? dayjs(row.ScInvDte).format("DD/MM/YYYY") : "-", colScInvDte + pl, yPos)
      doc.text(row.JobNo || "-", colJobNo + pl, yPos)
      doc.text(row.CmdyTyp || "-", colCmdyTyp + pl, yPos)
      doc.text(row.Loc || "-", colLoc + pl, yPos)
      doc.text(row.ContNo || "-", colContNo + pl, yPos)
      doc.text(row.SubDrvNm || "-", colDriver + pl, yPos)
      doc.text(row.SubLicNm || "-", colLicNm + pl, yPos)
      doc.text(numberFormat(exp1Amnt), colTrnsAmnt + colTrnsAmntWidth - pl, yPos, { align: "right" })
      doc.text(numberFormat(expOthAmnt), colOthAmnt + colOthAmntWidth - pl, yPos, { align: "right" })
      doc.text(numberFormat(totalAmnt), colTotal + colTotalWidth - pl, yPos, { align: "right" })
      yPos += lineHeightTable
    }

    curRow += MAX_ROW
    if (curRow < totalRow) {
      pageRow = 0
      doc.addPage(pageSize, "lanscape")
      continue
    } else {


      if (pageRow !== 0) {
        yPos = yPos - lineHeight + 0.1
        doc.line(colNo, yPos, colNo + boxWidth, yPos)
        yPos += lineHeight
        doc.setFont("THSarabun", "bold")
        doc.text("รวม", colContNo + pl, yPos)
        doc.text(numberFormat(sumExp1), colTrnsAmnt + colTrnsAmntWidth - pl, yPos, { align: "right" })
        doc.text(numberFormat(sumExpOth), colOthAmnt + colOthAmntWidth - pl, yPos, { align: "right" })
        doc.text(numberFormat(sumTotal), colTotal + colTotalWidth - pl, yPos, { align: "right" })

        console.log("pageRow::", pageRow, "exps.length::", exps.length)

        if (pageRow + 10 + exps.length > MAX_ROW+3) {
          pageRow = 0
          doc.addPage(pageSize, "lanscape")
          continue
        }
      } else {

      }
      yPos += lineHeight
      doc.setFontSize(contentSize + 3)
      doc.text("รายละเอียดค่าใช้จ่าย", startX, yPos)
      doc.setFontSize(contentSize)
      doc.setFont("THSarabun", "normal")
      yPos += lineHeight
      no = 0
      const noCol = startX + 0.3
      const expCol = noCol + 0.3
      const qtyCol = expCol + 1.7
      const totalCol = qtyCol + 1.5
      for (const exp of exps) {
        no++
        doc.text(no.toString(), noCol, yPos)
        doc.text(exp.ExpNm, expCol, yPos)
        doc.text(`${exp.Qty} X ${numberFormat(exp.UntPr)}`, qtyCol + 1, yPos, { align: "right" })
        doc.text(`${numberFormat(exp.Total)} บาท`, totalCol + 1, yPos, { align: "right" })
        yPos += lineHeightTable
      }
      doc.setFont("THSarabun", "bold")
      doc.text("รวม", expCol, yPos)
      doc.text(numberFormat(sumTotal), totalCol + 1, yPos, { align: "right" })
      yPos += lineHeightTable
      doc.text("หัก ณ ที่จ่าย", expCol, yPos)
      doc.text(numberFormat(sumWhtPr), totalCol + 1, yPos, { align: "right" })
      yPos += lineHeightTable
      doc.text("ยอดจ่าย", expCol, yPos)
      doc.text(numberFormat(sumTotal - sumWhtPr), totalCol + 1, yPos, { align: "right" }) 
      let xPosPayMthd = totalCol + 1.5
      doc.text("วิธีการจ่ายเงิน :", xPosPayMthd, yPos)
      doc.setFont("THSarabun", "normal")
      xPosPayMthd += 1
      doc.text(pvData.PV.PayMthdNm || "-", xPosPayMthd, yPos)
      if(pvData.PV.PayMthdId === 3){
        xPosPayMthd += 0.6
        doc.setFont("THSarabun", "bold")
        doc.text("บัญชี :", xPosPayMthd, yPos)
        doc.setFont("THSarabun", "normal")
        xPosPayMthd += 0.4
        doc.text(`${pvData.PV.TrnAccNm || "-"}`, xPosPayMthd, yPos)
        doc.text(`${pvData.PV.TrnBkAccNo || "-"}(ธ.${pvData.PV.TrnBkNm})`, xPosPayMthd, yPos + lineHeightTable)
      } else if(pvData.PV.PayMthdId === 2){
        xPosPayMthd += 0.6
        doc.setFont("THSarabun", "bold")
        doc.text("เลขที่ :", xPosPayMthd, yPos)
        doc.setFont("THSarabun", "normal")
        xPosPayMthd += 0.4
        doc.text(`${pvData.PV.ChqNo || "-"} ธ.${pvData.PV.ChqBkNm || "-"} วันที่: ${pvData.PV.ChqDte?dayjs(pvData.PV.ChqDte).format("DD/MM/YYYY"): "-"}`, xPosPayMthd, yPos)
      }
      yPos += lineHeightTable

      yPos += lineHeightTable

      doc.setFontSize(contentSize)
      doc.setFont("THSarabun", "bold")
      doc.text("หมายเหตุ: ", startX, yPos)
      doc.setFont("THSarabun", "normal")
      doc.text(pvData.PV.Rmk || "-", startX + 0.6, yPos)
      // printDataTable({
      //   title: "รายงานการจ่ายเงิน",
      //   dataTable: printRow,
      //   companyData: msData.serverData.CompanyData,
      //   columnHeader: printColumnHeader,
      //   isShowSum: false,
      //   extraData: extraData
      // })

      yPos += lineHeight * 3
      const singWidth = boxWidth / 6 - 0.2

      const signs = ["ผู้สั่งซื้อ", "ผู้อนุมัติ", "ผู้อนุมัติ(MGR.)", "ผู้อนุมัติ(DM.)", "ผู้อนุมัติ(CFO.)", "ผู้อนุมัติ(CEO.)"]
      xPos = colNo + 0.1
      for (let i = 0; i < signs.length; i++) {
        doc.line(xPos, yPos, xPos + singWidth, yPos)
        xPos += singWidth + 0.2
      }
      yPos += lineHeight
      xPos = colNo + 0.1
      for (const sing of signs) {
        doc.text(sing, xPos + singWidth / 2, yPos, { align: "center" })
        xPos += singWidth + 0.2
      }
      endLoop = true
    }
  }





  doc.output('dataurlnewwindow');

}